import { useCallback } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

type CreateEventFeature = 'useWebsiteDesignerV3' | 'useWeddingEventPagesAsCustomPages';

/**
 * Returns a function that computes the eventFeatures array based on
 * currently enabled feature flags. These features are passed to the
 * backend during event creation to configure the new event.
 */
export const useCreateEventFeatures = () => {
  const [isWebsiteDesignerV3Enabled] = useIsFeatureEnabled('websiteDesignerV3Enabled');
  const [isWebsiteAllPagesAsCustomPagesEnabled] = useIsFeatureEnabled('websiteAllPagesAsCustomPagesEnabled');

  const getEventFeatures = useCallback((): Array<CreateEventFeature> => {
    const features: Array<CreateEventFeature> = [];

    if (isWebsiteDesignerV3Enabled) {
      // Enables the V3 website designer
      features.push('useWebsiteDesignerV3');
    }
    if (isWebsiteAllPagesAsCustomPagesEnabled) {
      // for migrating legacy editor to joy-web as custom page
      features.push('useWeddingEventPagesAsCustomPages');
    }

    return features;
  }, [isWebsiteDesignerV3Enabled, isWebsiteAllPagesAsCustomPagesEnabled]);

  return { getEventFeatures };
};
